import { trigger, transition, animate, style, state } from '@angular/animations';

export const animations = [
  trigger('blurFadeInOut', [
    transition(':enter', [
      style({
        backdropFilter: 'blur(0px)',
        opacity: '0',
      }),
      animate(
        '400ms ease',
        style({
          backdropFilter: 'blur(8px)',
          opacity: '1',
        })
      ),
    ]),
    state('fadeIn', style({
      backdropFilter: 'blur(8px)',
      opacity: '1',
    })),
    state('fadeOut', style({
      backdropFilter: 'blur(0px)',
      opacity: '0',
    })),
    transition('fadeIn => fadeOut', animate('400ms ease')),
  ]),

  trigger('fadeInOut', [
    transition(':enter', [
      style({
        opacity: '0',
      }),
      animate(
        '500ms ease',
        style({
          opacity: '1',
        })
      ),
    ]),
    state('fadeIn', style({
      opacity: '1',
    })),
    state('fadeOut', style({
      opacity: '0',
    })),
    transition('fadeIn => fadeOut', animate('350ms ease')),
  ]),
  
];
